import { InsertDriveFile, OpenInNew } from "@mui/icons-material";
import { Box, Grid, Link, TextField, Typography } from "@mui/material";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { Container, Row } from "shards-react";
import ReusableModal from "../components/components-overview/Model";
import FeedbackDashboard from "./FeedbackDashboardData";

const FeedBackSummary = () => {
  const [summary, setSummary] = useState([]);
  const [loading, setLoading] = useState(false);
  const [token, setToken] = useState("");
  const [feedback, setMessageFeedback] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [currentRow, setCurrentRow] = useState({});
  const ratingColors = {
    1: "#D32F2F",
    2: "#F44336",
    3: "#FF5722",
    4: "#FF9800",
    5: "#FFEB3B",
    6: "#CDDC39",
    7: "#8BC34A",
    8: "#4CAF50",
    9: "#388E3C",
    10: "#2E7D32"
  };
  const userRole = localStorage.getItem("userRole");
  const isAdmin = userRole === "Admin" || userRole === "superAdmin";

  const handleOpenModal = row => {
    // setCurrentRow(row)
    setCurrentRow({
      ...row,
      reference_link: row.reference_link ? row.reference_link.split(",") : null
    });

    setOpenModal(true);
    console.log(row.reference_link, 34);
  };

  let columns = [
    {
      field: "id",
      headerName: "S.No",
      renderHeader: () => (
        <strong style={{ color: "rgb(28, 70, 146)" }}>{"SL. No"}</strong>
      ),
      headerAlign: "center",
      align: "center",

      renderCell: params => (
        <span style={{ pointerEvents: "none", userSelect: "none" }}>
          {params.api.getAllRowIds().indexOf(params.id) + 1}
        </span>
      )
    },
    // {
    //   field: "prediction_id",
    //   headerName: "Prediction ID",
    //   width: 130,
    //   align: "center",
    //   headerAlign: "center",
    //   renderCell: params => (
    //     <span style={{ color: "#1976D2", fontWeight: "bold" }}>
    //       {params.value}
    //     </span>
    //   )
    // },
    {
      field: "soil_type",
      headerName: "Soil Type",
      width: 80,
      align: "center",
      headerAlign: "center"
    },
    {
      field: "crop_type",
      headerName: "Crop Type",
      width: 80,
      align: "center",
      headerAlign: "center"
    },
    {
      field: "temperature",
      headerName: "Temperature (°C)",
      width: 130,
      align: "center",
      headerAlign: "center",
      renderCell: params => {
        let color =
          params.value < 15
            ? "#1976D2"
            : params.value > 35
            ? "#D32F2F"
            : "#333";
        return <span style={{ color }}>{params.value}°C</span>;
      }
    },
    {
      field: "humidity",
      headerName: "Humidity (%)",
      width: 100,
      align: "center",
      headerAlign: "center"
    },
    {
      field: "moisture",
      headerName: "Moisture (%)",
      width: 100,
      align: "center",
      headerAlign: "center"
    },
    {
      field: "nitrogen",
      headerName: "Nitrogen",
      width: 70,
      align: "center",
      headerAlign: "center",
      renderCell: params => (
        <span style={{ color: "#0288D1" }}>{params.value}</span>
      )
    },
    {
      field: "phosphorus",
      headerName: "Phosphorus",
      width: 100,
      align: "center",
      headerAlign: "center",
      renderCell: params => (
        <span style={{ color: "#F57C00" }}>{params.value}</span>
      )
    },
    {
      field: "potassium",
      headerName: "Potassium",
      width: 110,
      align: "center",
      headerAlign: "center",
      renderCell: params => (
        <span style={{ color: "#D32F2F" }}>{params.value}</span>
      )
    },
    {
      field: "predicted_at",
      headerName: "Predicted At",
      width: 160,
      align: "center",
      headerAlign: "center",
    },
    {
      field: "user_id",
      headerName: "FeedBack User",
      width: 220,
      align: "center",
      headerAlign: "center",
      renderCell: params => <span>{params.value}</span>
    },
    {
      field: "predicted_npk",
      headerName: "Predicted NPK",
      width: 150,
      align: "center",
      headerAlign: "center",
      renderCell: params => (
        <strong style={{ color: "#388E3C" }}>{params.value}</strong>
      )
    },
    {
      field: "Set",
      headerName: "",
      width: 150,
      renderCell: params => (
        <div
          style={{ cursor: "pointer", textDecoration: "underline" }}
          onClick={() => handleOpenModal(params.row)}
        >
          <button
            style={{
              border: "none",
              backgroundColor: "transparent",
              cursor: "pointer",
              textDecoration: "underline",
              color: "green"
            }}
          >
            View Details
          </button>
        </div>
      )
    }
    // {
    //   field: "model_type",
    //   headerName: "Model Type",
    //   width: 130,
    //   align: "center",
    //   headerAlign: "center"
    // },
    // {
    //   field: "score",
    //   headerName: "Score",
    //   width: 100,
    //   align: "center",
    //   headerAlign: "center"
    // },
    // {
    //   field: "confidence_level",
    //   headerName: "Confidence Level",
    //   width: 150,
    //   align: "center",
    //   headerAlign: "center",
    //   renderCell: params => {
    // let color =
    //   params.value === "High"
    //     ? "#2E7D32"
    //     : params.value === "Medium"
    //     ? "#FF9800"
    //     : "#D32F2F";
    //     return (
    //       <span style={{ color, fontWeight: "bold" }}>{params.value}</span>
    //     );
    //   }
    // },
    // {
    //   field: "comments",
    //   headerName: "Comments",
    //   width: 200,
    //   align: "center",
    //   headerAlign: "center"
    // },
    // {
    //   field: "alternative_npk",
    //   headerName: "Alternative NPK",
    //   width: 150,
    //   align: "center",
    //   headerAlign: "center"
    // },
    // {
    //   field: "AgroZone",
    //   headerName: "Agro Zone",
    //   width: 130,
    //   align: "center",
    //   headerAlign: "center"
    // },
    // {
    //   field: "Season",
    //   headerName: "Season",
    //   width: 130,
    //   align: "center",
    //   headerAlign: "center"
    // },
    // {
    //   field: "reference_link",
    //   headerName: "Reference Link",
    //   width: 250,
    //   align: "center",
    //   headerAlign: "center",
    //   renderCell: params => {
    //     if (!params.value) return "N/A";

    //     const links = params.value.split(","); // Split multiple links by comma

    //     return (
    //       <div style={{ display: "flex", flexDirection: "row", gap: "5px" }}>
    //         {links.map((link, index) => (
    //           <a
    //             key={index}
    //             href={`${link.trim()}?${token}`} // Trim to remove any extra spaces
    //             target="_blank"
    //             rel="noopener noreferrer"
    //             style={{ color: "#1976D2", textDecoration: "underline" }}
    //           >
    //             <OpenInNew fontSize="small" />
    //           </a>
    //         ))}
    //       </div>
    //     );
    //   }
    // }
  ];

  // Add approval column only if the user is Admin or superAdmin
  if (isAdmin) {
    columns.push({
      field: "approval",
      headerName: "",
      width: 180,
      align: "center",
      headerAlign: "center",
      renderCell: params => {
        const { status, id } = params.row;

        if (status === "Pending") {
          return (
            <div style={{ display: "flex", gap: "8px" }}>
              <button
                style={{
                  backgroundColor: "#2E7D32",
                  color: "white",
                  border: "none",
                  padding: "5px 10px",
                  cursor: "pointer",
                  borderRadius: "5px"
                }}
                onClick={() => handleApproval(id, "Approved")}
              >
                Approve
              </button>
              <button
                style={{
                  backgroundColor: "#D32F2F",
                  color: "white",
                  border: "none",
                  padding: "5px 10px",
                  cursor: "pointer",
                  borderRadius: "5px"
                }}
                onClick={() => handleApproval(id, "Rejected")}
              >
                Reject
              </button>
            </div>
          );
        }

        return (
          <button
            style={{
              backgroundColor: status === "Approved" ? "#2E7D32" : "#D32F2F",
              color: "white",
              border: "none",
              padding: "5px 10px",
              borderRadius: "5px",
              cursor: "default",
              opacity: 0.6
            }}
            disabled
          >
            {status}
          </button>
        );
      }
    });
  }

  const handleApproval = async (id, status) => {
    try {
      let response = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/feedback/approval`,
        {
          status: status,
          feedback_id: id
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("userToken")}`, // Replace with your token source
            "Content-Type": "application/json"
          }
        }
      );

      if (response.data.status === "success") {
        setMessageFeedback(prev => !prev);
      }
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      let response;
      try {
        if (localStorage.getItem("userRole") == "Expert") {
          response = await axios.get(
            `${process.env.REACT_APP_BASE_URL}/fertilizer/recommendation/get/expert/feedback/uid`,
            {
              headers: {
                Authorization: `Bearer ${localStorage.getItem("userToken")}`, // Replace with your token source
                "Content-Type": "application/json"
              }
            }
          );
        } else {
          response = await axios.get(
            `${process.env.REACT_APP_BASE_URL}/fertilizer/recommendation/get/expert/feedback`,
            {
              headers: {
                Authorization: `Bearer ${localStorage.getItem("userToken")}`, // Replace with your token source
                "Content-Type": "application/json"
              }
            }
          );
        }

        console.log(response, 63);

        if (response.data.status === "success") {
          const updatedData = response.data.data.map(item => {
            const originalDate = new Date(item.predicted_at);
            const updatedDate = new Date(originalDate.getTime() + 5.5 * 60 * 60 * 1000);
            const formattedDate = updatedDate.toLocaleString().slice(0, 19).replace("T", " ");

        
            return {
              ...item,
              predicted_at: formattedDate
            };
          });
          
          setSummary(updatedData);
        }
      } catch (err) {
        console.log(err);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [feedback]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        let response = await axios.get(
          `${process.env.REACT_APP_BASE_URL}/generate-sas-token?container=expert-feedback-module`,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("userToken")}`, // Replace with your token source
              "Content-Type": "application/json"
            }
          }
        );

        if (response.data.status === "success") {
          setToken(response.data.sas_token);
        }
      } catch (err) {
        console.log(err);
      }
    };

    fetchData();
  }, []);

  return (
    <Container
      fluid
      className="main-content-container px-4 py-4"
      style={{ backgroundColor: "white" }}
    >
      <FeedbackDashboard />
      <Grid container spacing={2}>
        <Grid item xs={12} style={{ maxHeight: 600 }}>
          <DataGrid
            getRowId={data => data.predicted_at}
            rows={summary}
            loading={loading}
            columns={columns}
            density="compact"
            rowSelection={false}
            rowCount={100}
            paginationMode="server"
            style={{ minHeight: 200 }}
            components={{ Toolbar: GridToolbar }}
          />
        </Grid>
      </Grid>

      <ReusableModal
        width="58.906vw"
        height="80%"
        open={openModal}
        onClose={() => {
          setOpenModal(false);
        }}
      >
        <Box>
          <Grid container>
            <Grid item xs={12} style={{ paddingBottom: "3rem" }}>
              <Typography
                sx={{
                  color: "rgba(0, 0, 0, 0.80)",
                  textAlign: "center",
                  fontFeatureSettings: "'ss01' on, 'cv01' on, 'cv11' on",
                  fontFamily: "Inter",
                  fontSize: "1.5rem",
                  fontStyle: "normal",
                  fontWeight: 600,
                  lineHeight: "1.125rem" // 75%
                }}
              >
                Feedback
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <Typography
                sx={{
                  color: "#000",
                  fontFeatureSettings: "'ss01' on, 'cv01' on, 'cv11' on",
                  fontFamily: "Inter",
                  fontSize: "1.25rem",
                  fontStyle: "normal",
                  fontWeight: 500,
                  lineHeight: "1.125rem" // 75%
                }}
              >
                1: Accuracy of the Model’s prediction
              </Typography>
            </Grid>
            <Grid
              item
              xs={12}
              style={{ marginTop: "1.12rem", marginBottom: "2.25rem" }}
            >
              <Grid
                item
                sx={{
                  display: "flex",
                  width: "2.5rem",
                  height: "2.5rem",
                  padding: "0.625rem 0.5rem",
                  justifyContent: "center",
                  alignItems: "center",
                  gap: "0.625rem",
                  flexShrink: 0,
                  borderRadius: "0.25rem",
                  background: ratingColors[currentRow.score],
                  color: "#FFFFFF",
                  cursor: "pointer",
                  fontFamily: "Inter",
                  fontSize: "0.875rem",
                  fontStyle: "normal",
                  fontWeight: 400,
                  lineHeight: "1.125rem"
                }}
              >
                {currentRow.score}
              </Grid>
            </Grid>
            <Grid item xs={12}>
              <Typography
                sx={{
                  color: "#000",
                  fontFeatureSettings: "'ss01' on, 'cv01' on, 'cv11' on",
                  fontFamily: "Inter",
                  fontSize: "1.25rem",
                  fontStyle: "normal",
                  fontWeight: 500,
                  lineHeight: "1.125rem" // 75%
                }}
              >
                2: Reason behind the choice
              </Typography>
            </Grid>
            <Grid
              item
              xs={12}
              style={{ marginTop: "1.12rem", marginBottom: "2.25rem" }}
            >
              <Box
                sx={{
                  overflowY: "auto",
                  maxHeight: "500px",
                  padding: "1rem",
                  width: "100%" // Ensures full width inside the Grid container
                }}
              >
                <Grid item>
                  <TextField
                    multiline
                    rows={4}
                    value={currentRow.comments}
                    sx={{
                      width: "40.125rem",
                      flexShrink: 0,
                      borderRadius: "0.25rem",
                      border: "1px solid #C0C0C0",
                      background: "#FFF",
                      boxShadow: "0px 1px 2px 0px rgba(0, 0, 0, 0.10)",
                      color: "#555",
                      fontFamily: "Inter",
                      fontSize: "0.875rem",
                      fontStyle: "normal",
                      fontWeight: 400,
                      lineHeight: "1.125rem",
                      "& .MuiOutlinedInput-root": {
                        borderRadius: "0.25rem"
                      }
                    }}
                  />
                </Grid>
              </Box>
            </Grid>
            <Grid item xs={12}>
              <Typography
                sx={{
                  color: "#000",
                  fontFeatureSettings: "'ss01' on, 'cv01' on, 'cv11' on",
                  fontFamily: "Inter",
                  fontSize: "1.25rem",
                  fontStyle: "normal",
                  fontWeight: 500,
                  lineHeight: "1.125rem" // 75%
                }}
              >
                3: Reference link/research paper
              </Typography>
            </Grid>
            <Grid item xs={12} style={{ marginTop: "1.12rem" }}>
              <Grid container spacing={2}>
                {currentRow.reference_link &&
                  currentRow.reference_link.map((file, index) => {
                    let fileName = file.split("/").pop();

                    return (
                      <Grid item key={index}>
                        <Link
                          href={`${file.trim()}?${token}`}
                          sx={{
                            textDecoration: "none",
                            color: "#555",
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            justifyContent: "center",
                            flexShrink: 0,
                            color: "#006BE0",
                            fontFamily: "Inter",
                            fontSize: "0.875rem",
                            fontStyle: "normal",
                            fontWeight: 500,
                            lineHeight: "1.125rem"
                          }}
                        >
                          <InsertDriveFile
                            style={{ fontSize: "30px", color: "#757575" }}
                          />
                          <Typography variant="body2">{fileName}</Typography>
                        </Link>
                      </Grid>
                    );
                  })}
              </Grid>
            </Grid>
            <Grid item xs={12} style={{ marginTop: "2.25rem" }}>
              <Typography
                sx={{
                  color: "#000",
                  fontFeatureSettings: "'ss01' on, 'cv01' on, 'cv11' on",
                  fontFamily: "Inter",
                  fontSize: "1.25rem",
                  fontStyle: "normal",
                  fontWeight: 500,
                  lineHeight: "1.125rem" // 75%
                }}
              >
                4: Confidence level of the recommendation
              </Typography>
            </Grid>
            <Grid item xs={12} style={{ marginTop: "1.12rem" }}>
              <Grid
                item
                sx={{
                  display: "flex",
                  width: "5.3125rem",
                  height: "2.5rem",
                  padding: "0.625rem 1rem",
                  justifyContent: "center",
                  alignItems: "center",
                  gap: "0.625rem",
                  flexShrink: 0,
                  borderRadius: "0.25rem",
                  background:
                    currentRow["confidence_level"] == "High"
                      ? "#2E7D32"
                      : currentRow["confidence_level"] == "Medium"
                      ? "#FF9800"
                      : "#D32F2F",
                  color: "#FFFFFF",
                  cursor: "pointer",
                  fontFamily: "Inter",
                  fontSize: "0.875rem",
                  fontStyle: "normal",
                  fontWeight: 400,
                  lineHeight: "1.125rem" /* 128.571% */
                }}
              >
                {currentRow.confidence_level}
              </Grid>
            </Grid>
            <Grid item xs={12} style={{ marginTop: "2.25rem" }}>
              <Typography
                sx={{
                  color: "#000",
                  fontFeatureSettings: "'ss01' on, 'cv01' on, 'cv11' on",
                  fontFamily: "Inter",
                  fontSize: "1.25rem",
                  fontStyle: "normal",
                  fontWeight: 500,
                  lineHeight: "1.125rem" // 75%
                }}
              >
                5: Alternative N-P-K ratio
              </Typography>
            </Grid>
            <Grid item xs={12} style={{ marginTop: "1.12rem" }}>
              <Typography
                sx={{
                  color: "#006BE0",
                  fontFamily: "Inter",
                  fontSize: "0.875rem",
                  fontStyle: "normal",
                  fontWeight: 500,
                  lineHeight: "1.125rem" // 75%
                }}
              >
                {currentRow.alternative_npk}
              </Typography>
            </Grid>
            {currentRow.alternative_npk && (
              <>
                <Grid item xs={12} style={{ marginTop: "2.25rem" }}>
                  <Typography
                    sx={{
                      color: "#000",
                      fontFeatureSettings: "'ss01' on, 'cv01' on, 'cv11' on",
                      fontFamily: "Inter",
                      fontSize: "1.25rem",
                      fontStyle: "normal",
                      fontWeight: 500,
                      lineHeight: "1.125rem" // 75%
                    }}
                  >
                    6: Based on suggested alternative N-P-K ratio, selected
                    region and season
                  </Typography>
                </Grid>
                <Grid item xs={12} style={{ marginTop: "1.12rem" }}>
                  <Grid container>
                    <Grid item>
                      <Typography
                        sx={{
                          color: "#232323",
                          fontFamily: "Inter",
                          fontSize: "0.875rem",
                          fontStyle: "normal",
                          fontWeight: 500,
                          lineHeight: "1.125rem"
                        }}
                      >
                        <span>Region:</span>
                        <span style={{ color: "#006BE0" }}>
                          {currentRow.AgroZone}
                        </span>
                      </Typography>
                    </Grid>
                    <Grid item style={{ marginLeft: "1.75rem" }}>
                      <Typography
                        style={{
                          color: "#232323",
                          fontFamily: "Inter",
                          fontSize: "0.875rem",
                          fontStyle: "normal",
                          fontWeight: 500,
                          lineHeight: "1.125rem"
                        }}
                      >
                        <span>Season:</span>
                        <span style={{ color: "#006BE0" }}>
                          {currentRow.Season}
                        </span>
                      </Typography>
                    </Grid>
                  </Grid>
                </Grid>
              </>
            )}
          </Grid>
        </Box>
      </ReusableModal>
    </Container>
  );
};

export default FeedBackSummary;
